import React from 'react'
import AccountTreeOutlined from '@material-ui/icons/AccountTreeOutlined'

export default function AccountTreeOutlinedIcon() {

    return (
        <AccountTreeOutlined />
    )
}